// @ts-nocheck
import { Modal } from 'semantic-ui-react';

import Form from '@rjsf/material-ui';
import validator from '@rjsf/validator-ajv8';
import React from 'react';

const getUISchema = (formSchema) => {
  return Object.keys(formSchema.properties).reduce((acc, curr) => {
    if (formSchema.properties[curr].type === 'boolean') {
      acc[curr] = {
        'ui:options': {
          component: 'select',
          options: {
            label: true,
          },
        },
      };
    }
    return acc;
  }, {});
};

type MyProps = {
  onClose: any;
  update: any;
  formSchema: any;
  formData?: any;
  noValidate?: boolean;
};

const EditDialog = React.memo((props: MyProps) => {
  const handleSubmit = (data: any) => {
    props.update(data.formData);
    props.onClose();
  };

  return (
    <Modal open={true} onClose={props.onClose} dimmer={false}>
      <Modal.Content>
        <Form
          validator={validator}
          schema={props.formSchema}
          uiSchema={getUISchema(props.formSchema)}
          onSubmit={handleSubmit}
          formData={props.formData}
          noValidate={props.noValidate || false}
        />
      </Modal.Content>
    </Modal>
  );
});

export default EditDialog;
